<script>
import {
  defineComponent, onMounted, ref,
} from '@vue/composition-api';
import { useManagerDashboard } from '../../composables/useManagerDashboard';
import DashboardGraphBar from './DashboardGraphBar.vue';

export default defineComponent({
  components: {
    DashboardGraphBar,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: () => true,
    },
  },
  setup(props) {
    const formattedData = ref([]);
    const maxValue = ref(1);
    const currentSelected = ref({});
    const { changeCurrentRevenue } = useManagerDashboard();

    const selectBar = (bar) => {
      if (bar === currentSelected.value) {
        // eslint-disable-next-line no-param-reassign
        if (!bar.selected) bar.selected = true;
      } else {
        currentSelected.value.selected = false;
        // eslint-disable-next-line no-param-reassign
        bar.selected = true;
        currentSelected.value = bar;
      }
      changeCurrentRevenue(bar);
    };

    onMounted(() => {
      formattedData.value = props.data
        .map((el) => ({ ...el, total: parseInt(el.total, 10), selected: false }))
        .slice(0, 6)
        .reverse();

      selectBar(formattedData.value[formattedData.value.length - 1]);

      const revenuesTotals = props.data.map((el) => el.total);
      maxValue.value = Math.max(...revenuesTotals);
    });
    return {
      formattedData,
      selectBar,
      maxValue,
    };
  },
});
</script>

<template>
  <div class="graph">
    <DashboardGraphBar
      v-for="(bar, index) in formattedData"
      :key="index"
      :selected="bar.selected"
      :value="bar.total"
      :date="bar.date"
      :height="(bar.total / maxValue) * 100"
      @click="selectBar(bar)"
    />
  </div>
</template>
<style lang="scss" scoped>
.graph {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
}
</style>
